import axios from 'axios';
import { convertQuestionsToArray } from '../../../../components/CASAForm/Utilities';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';

export const SUBMISSION_BEGIN = 'SUBMISSION_BEGIN';
export const SUBMISSION_SUCCESS = 'SUBMISSION_SUCCESS';
export const SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';

export const submissionBegin = () => ({
    type: SUBMISSION_BEGIN
});

export const submissionSuccess = (value) => ({
    type: SUBMISSION_SUCCESS,
    payload: value
});

export const submissionFailure = (error) => ({
    type: SUBMISSION_FAILURE,
    payload: error
});

export const submitForm = (webappurlForms, accessToken, formProperties, formData) => {
    return dispatch => {
        var data = {
            'rootFormCode': formProperties.rootFormCode,
            'formCode': formProperties.formCode,
            'formData': {
                'steps': convertQuestionsToArray(formData.steps),
                'calcs': Object.values(formData.calcs)
            },
            'name': formProperties.name,
            'version': formProperties.version,
            'orgid': formProperties.orgid,
            'draftRecordId': formProperties.draftRecordId
        };

        const options = {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        dispatch(submissionBegin());
        return axios.post(webappurlForms + '/api/myCASA/Forms/SubmitForm/v1', data, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(submissionSuccess());
                }
                else {
                    dispatch(addFormSubmissionFailed());
                    return dispatch(submissionFailure(response.data.error));
                }
            })
            .catch(error => {
                dispatch(addFormSubmissionFailed());
                return dispatch(submissionFailure(error.response ? error.response.data.errors : error));
            });
    };
};